import { ProductResponse } from "./product.model";
import { VendorResponse } from "./vendor.model";
import { WarehouseResponse } from "./warehouse.model";

export class PurchaseOrderRequest {
  creationDate: Date;
  deliveryDate: Date;
  provider: number;
  description: String;
  currency: number;
  detail: PurchaseOrderDetailRequest[] = [];
}

export class PurchaseOrderDetailRequest {
  product: number;
  warehouse: number;
  quantity: number;
  toReceive: number;
  cost: number;

  constructor(product: number, warehouse: number, quantity: number, toReceive: number, cost: number) {
    this.product = product;
    this.warehouse = warehouse;
    this.quantity = quantity;
    this.toReceive = toReceive;
    this.cost = cost;
  }
}

export interface PurchaseOrderResponse {
  id: number;
  number: number;
  creationDate: Date;
  deliveryDate: Date;
  active: boolean;
  user: number;
  provider: number;
  company: number;
  description: string;
  statusType: number;
  statusName: string;
  currency: number;
  exchangeRate: number;
  enteredIntoInventory: boolean;
  providerData?: VendorResponse;
}

export interface PurchaseOrderDetailResponse {
  id: number;
  purchaseOrder: number;
  product: number;
  warehouse: number;
  quantity: number;
  toReceive: number;
  cost: number;
  quantityReceived: number;
  statusType: number;
  statusName: string;
  productData?: ProductResponse;
  warehouseData?: WarehouseResponse;
}

export interface ReportPurchaseOrderDays {
  deliveryDate: Date;
  productId: number;
  productName: string;
  totalQuantity: number;
  totalToReceive: number;
  totalReceived: number;
  totalCost: number;
}

export interface ReportPurchaseOrderDatesWeeks {
  startDate: Date;
  endDate: Date;
  purchaseDetails: ReportPurchaseOrderWeeks[];
}

export interface ReportPurchaseOrderWeeks {
  productId: number;
  productName: string;
  totalQuantity: number;
  totalToReceive: number;
  totalReceived: number;
  totalCost: number;
}